import { SCClientSocket } from 'socketcluster-client';

const SOCKET_ACCESS_TOKEN = 'ae490b57eced4be98827c3146f759998';

const CODES = {
  SymbolTradePriceChangeSignal: 56,
  SymbolTradePriceChangePreOpeningSignal: 62,
  SymbolBidAskChangeSignal: 14,
  SymbolIndividualFirmSignal: 13,
  SymbolMarketDepthChangeSignal: 29,
  TseInstrumentClosingPriceChangeSignal: 57,
  TseTimeSection: 15,
  TseChangeSignal: 16,
  MdpContentSignal: 19,
  OmsResultSignal: 23,
  NewsContentSignal: 58,
  OmsOrderNoticeCancelSignal: 24,
  OmsOrderNoticeModifySignal: 25,
  OmsOrderNoticeCreationSignal: 26,
  OmsTradeCreationNoticeSignal: 27,
  OmsAccountStateChangeSignal: 28,
  WithdrawalChangeStateSignal: 54,
  InitialPublicOfferChange: 18,
  SymbolStateChangeSignal: 70,
  MdpIndexSignal: 63,
  MdpIndividualSignal: 64,
  OmsOrderAndTradeSignal: 67,
  NewOmsOrderAndTradeSignal: 72,
  MarketMapSignal: 40,
  MdpNavSignal: 65,
  OmsNewAccountStateChangeSignal: 71,
  PortfolioUpdateSignal: 69,
} as const;

function createSocketConfig(user: string): SCClientSocket.ClientOptions {
  return {
    hostname: 'streaming.farabixo.com',
    path: '/socketcluster/',
    rejectUnauthorized: false,
    autoReconnect: true,
    multiplex: true,
    secure: true,
    port: 443,
    query: {
      ...(import.meta.env.DEV && { accessToken: SOCKET_ACCESS_TOKEN }),
      user,
      device: import.meta.env.VITE_APP_DEVICE,
    },
    authTokenName: 'authorizationToken',
  };
}

export { CODES, createSocketConfig };
